module.exports = __webpack_public_path__ + "static/bg-sec3-sm-d2afef7cdca5d205443ff83731dca25e.jpg";